/* eslint-disable new-cap */
/* eslint-disable no-new */
import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import useScreenSize from '../useScreenSize';
import { Adriver, AdriverCustom, TargetedBannerIds } from '../../types';

const lotriverBGLeftClass = '.lotriver-bg-left';
const lotriverBGRightClass = '.lotriver-bg-right';

const formatCustomData = (custom: object): string => {
  return Object.entries(custom)
    .map(([key, value]) => `${key}=${value}`)
    .join(';');
};

export const useTargetedBanner = (
  bannerId: TargetedBannerIds,
  custom: AdriverCustom,
  shouldNotRunOnRouter: boolean
) => {
  const isFirstRun = useRef(true);
  const { isLarge } = useScreenSize();
  const banner = useRef<null | Adriver>(null);
  const router = useRouter();

  const isPashaPage = router.pathname === '/pasha/[[...search]]';

  const bannerData = {
    [TargetedBannerIds.bg]: { sid: 220686, bt: 52, bn: 4, custom },
    [TargetedBannerIds.catfish]: {
      sid: 220686,
      bn: 5,
      bt: 52,
      w: 700,
      h: 120,
      custom
    }
  };

  useEffect(() => {
    if (!Object.keys(custom).length) return;

    if (!isFirstRun.current && shouldNotRunOnRouter) return;

    setTimeout(() => {
      try {
        banner.current = new window.adriver(bannerId, bannerData[bannerId]);
      } catch (e) {
        console.error(e);
      }
    }, 2000);
  }, [custom]);

  useEffect(() => {
    if (!isFirstRun.current && shouldNotRunOnRouter) return;

    const bannerElement = document.getElementById(bannerId);
    if (
      banner.current &&
      banner.current?.loadCompleteQueue?.flag &&
      bannerElement
    ) {
      if (bannerId === TargetedBannerIds.bg) {
        document.querySelector(lotriverBGLeftClass)?.remove();
        document.querySelector(lotriverBGRightClass)?.remove();
      }
      bannerElement.innerHTML = '';

      if (banner.current?.prm) {
        banner.current.prm.custom = custom;
      }
      if (banner.current?.reqPrm) {
        banner.current.reqPrm.custom = formatCustomData(custom);
      }
      banner.current?.reload();
    }
  }, [router]);

  useEffect(() => {
    const leftBanner = document.querySelector(
      lotriverBGLeftClass
    ) as HTMLElement | null;
    const rightBanner = document.querySelector(
      lotriverBGRightClass
    ) as HTMLElement | null;

    if (leftBanner && rightBanner && !isPashaPage) {
      leftBanner.style.display = isLarge ? 'block' : 'none';
      rightBanner.style.display = isLarge ? 'block' : 'none';
    }
  }, [isLarge]);

  useEffect(() => {
    const isHomePage = router.pathname === '/';

    if (isHomePage) return;

    if (!isFirstRun.current && shouldNotRunOnRouter) return;
    isFirstRun.current = false;

    if (bannerId === TargetedBannerIds.bg) {
      document.querySelector(lotriverBGLeftClass)?.remove();
      document.querySelector(lotriverBGRightClass)?.remove();
    }

    const bannerElement = document.getElementById(bannerId);
    if (bannerElement) {
      bannerElement.innerHTML = '';
    }

    if (typeof window !== 'undefined' && typeof window.adriver === 'function') {
      window.adriver(bannerId, {
        ...(bannerData[bannerId] || {}),
        custom
      });
    }
  }, [router.asPath, shouldNotRunOnRouter]);
  return null;
};
